import React, {useState} from "react";
import {Button, Modal} from "react-bootstrap";
import { Form } from "semantic-ui-react";
import useAuth from "../../../login/AuthContext";
import {CreatePortfolio} from "../../../../services/PortfolioApi";

interface CreatePortfolioModalProps {
    show: boolean;
    onClose: () => void;
}

export const CreatePortfolioModal: React.FunctionComponent<CreatePortfolioModalProps> = ({show, onClose}) => {
    const [name, setName] = useState<string>("");
    const [contactUrl, setContactUrl] = useState<string>("");
    const {getAuthToken} = useAuth();

    const validateFields = () => {
        let errored = false;

        errored = errored || name == "";

        return !errored;
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Create a portfolio</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={async () => {
                    if (validateFields()) {
                        CreatePortfolio(name, contactUrl, await getAuthToken());
                    }
                }}>
                    <Form.Field>
                        <label>Portfolio Name</label>
                        <input placeholder={"Portfolio Name"}
                               onChange={(event) => {
                                   setName(event.target.value);
                               }}
                        />
                        <label>Contact Url</label>
                        <input placeholder={"Contact Url"}
                               onChange={(event) => {
                                   setContactUrl(event.target.value);
                               }}
                        />
                    </Form.Field>
                    <Button style={{ marginTop: "5px" }} type="submit">
                        Add
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};